import type { Board } from '@/entities/board';
import type { AccessibleBoard } from '@/entities/collab';

/**
 * A board as the calendar needs it (colour, name, workspace). The list of accessible boards has no
 * default column or look: those stay empty, the calendar never reads them for a global calendar.
 */
export function calendarBoardOf(board: AccessibleBoard): Board {
  return {
    id: board.id,
    workspace_id: board.workspace_id,
    name: board.name,
    description: board.description,
    color: board.color,
    appearance: board.appearance,
    background_image_url: board.background_image_url,
    default_column_id: null,
    owner_user_id: board.owner_user_id,
    created_by_user_id: null,
    origin_team_id: null,
    visibility: 'private',
    version: 0,
    is_favorite: board.is_favorite,
    created_at: board.created_at,
    updated_at: board.updated_at,
    workweek_days: [1, 2, 3, 4, 5],
  };
}
